export enum PixelFormatName {
  AlphaFormat = 'AlphaFormat',
  DepthFormat = 'DepthFormat',
  DepthStencilFormat = 'DepthStencilFormat',
  RGBAFormat = 'RGBAFormat',
  RGBAIntegerFormat = 'RGBAIntegerFormat',
  RGBFormat = 'RGBFormat',
  RGBIntegerFormat = 'RGBIntegerFormat',
  RGFormat = 'RGFormat',
  RGIntegerFormat = 'RGIntegerFormat',
  RedFormat = 'RedFormat',
  RedIntegerFormat = 'RedIntegerFormat'
}
